import * as stylex from "@stylexjs/stylex";
import {
  breakpoints,
  colors,
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";

export const headerStyles = stylex.create({
  accent: (accent: string) => ({ "--accent": accent }),
  hero: {
    position: "relative",
    overflow: "hidden",
    borderRadius: 18,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor:
      "color-mix(in srgb, var(--softmax-color-play-ink) 14%, transparent)",
    backgroundColor: colors.playInk,
    fontFamily: fonts.sans,
    lineHeight: 1.6,
    flex: "none",
    order: { default: null, [breakpoints.playCompact]: 0 },
  },
  cover: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  coverPosition: (focal: string, focalPhone: string) => ({
    objectPosition: {
      default: focal,
      [breakpoints.playCompact]: focalPhone,
    },
  }),
  coverBlank: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "var(--accent)",
    backgroundImage:
      "radial-gradient(circle at 18% 30%, color-mix(in srgb, var(--accent) 70%, white) 0, transparent 46%), radial-gradient(circle at 80% 80%, color-mix(in srgb, var(--accent) 55%, black) 0, transparent 52%)",
  },
  heroBody: {
    position: "relative",
    display: "grid",
    gridTemplateColumns: {
      default: "1fr auto",
      [breakpoints.playCompact]: "1fr",
    },
    alignItems: { default: "end", [breakpoints.playCompact]: "start" },
    gap: {
      default: spacing.space24,
      [breakpoints.playCompact]: spacing.space14,
    },
    minHeight: { default: 312, [breakpoints.playCompact]: 0 },
    boxSizing: "border-box",
    paddingBlock: {
      default: spacing.space28,
      [breakpoints.playCompact]: spacing.space20,
    },
    paddingInline: {
      default: spacing.space36,
      [breakpoints.playCompact]: spacing.space20,
    },
    color: colors.playPaper,
    backgroundColor: {
      default: "transparent",
      [breakpoints.playCompact]:
        "color-mix(in srgb, var(--softmax-color-play-hero-shade) 68%, transparent)",
    },
    backgroundImage: {
      default:
        "linear-gradient(0deg, color-mix(in srgb, var(--softmax-color-play-hero-shade) 88%, transparent) 0%, color-mix(in srgb, var(--softmax-color-play-hero-shade) 66%, transparent) 55%, color-mix(in srgb, var(--softmax-color-play-hero-shade) 20%, transparent) 100%)",
      [breakpoints.playCompact]: "none",
    },
  },
  heroRow: {
    containerType: "inline-size",
    display: "flex",
    flexDirection: { default: "row", [breakpoints.playCompact]: "column" },
    alignItems: "flex-end",
    gap: {
      default: spacing.space24,
      [breakpoints.playCompact]: spacing.space14,
    },
    minWidth: 0,
  },
  heroText: { flex: 1, minWidth: 0 },
  name: {
    margin: 0,
    fontFamily: fonts.mono,
    fontSize: {
      default: fontSizes.coworldTitle,
      [breakpoints.playCompact]: 30,
    },
    lineHeight: 1.05,
    fontWeight: 600,
    letterSpacing: "-0.01em",
  },
  leagueNote: {
    display: { default: "inline", [breakpoints.playCompact]: "block" },
    marginLeft: { default: spacing.space14, [breakpoints.playCompact]: 0 },
    marginTop: { default: 0, [breakpoints.playCompact]: spacing.space4 },
    fontFamily: fonts.sans,
    fontSize: fontSizes.body,
    fontWeight: 400,
    opacity: 0.8,
  },
  pitch: {
    marginTop: spacing.space8,
    marginInline: 0,
    marginBottom: spacing.space14,
    maxWidth: "62ch",
    fontSize: fontSizes.body,
    lineHeight: 1.45,
    opacity: 0.92,
  },
});
